import React, { useState, useEffect, useCallback } from 'react';
import { db } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import './Collab.css';

const SKELETON_COUNT = 4;

export default function Collab() {
  const [collabs, setCollabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(false);

  const loadCollabs = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const snap = await getDoc(doc(db, 'settings', 'homepage'));
      if (snap.exists()) {
        const data = snap.data();
        const allCollabs = data.collabs || [];
        setCollabs(allCollabs.filter(c => c.enabled !== false));
      }
    } catch (err) {
      console.error('Error loading collaborations:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadCollabs(); }, [loadCollabs]);

  /* ── Skeleton state ───────────────────────────────────────────────────── */
  if (loading) {
    return (
      <section className="collab-section">
        <div className="collab-inner">
          <p className="collab-eyebrow">Business Partners</p>
          <h2 className="collab-heading">Our Collaborations</h2>
          <div className="collab-skeleton-grid">
            {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
              <div key={i} className="collab-skeleton-card">
                <div className="collab-skeleton-image" />
                <div className="collab-skeleton-footer">
                  <div className="collab-skeleton-line" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  /* ── Error / offline state ────────────────────────────────────────────── */
  if (error) {
    return (
      <section className="collab-section">
        <div className="collab-inner">
          <p className="collab-eyebrow">Business Partners</p>
          <h2 className="collab-heading">Our Collaborations</h2>
          <div className="collab-error-state">
            <p className="collab-error-msg">Could not load collaborations. Check your connection.</p>
            <button className="collab-retry-btn" onClick={loadCollabs}>Try Again</button>
          </div>
        </div>
      </section>
    );
  }

  /* ── Empty / hidden ───────────────────────────────────────────────────── */
  if (collabs.length === 0) return null;

  /* ── Normal render ────────────────────────────────────────────────────── */
  return (
    <section className="collab-section">
      <div className="collab-inner">
        <p className="collab-eyebrow">Business Partners</p>
        <h2 className="collab-heading">Our Collaborations</h2>
        <div className="collab-grid">
          {collabs.map((item) => (
            <div className="collab-card" key={item.id}>
              <div className="collab-card-image-wrap">
                <img src={item.imageUrl} alt={item.title} className="collab-card-image" />
              </div>
              <div className="collab-card-footer">
                <h3 className="collab-card-title">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}